import { render, staticRenderFns } from "./EventOrderList.vue?vue&type=template&id=2448ce24"
import script from "./EventOrderList.vue?vue&type=script&lang=js"
export * from "./EventOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports